import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-people-signup',
  templateUrl: './people-signup.component.html',
  styleUrls: ['./people-signup.component.sass']
})
export class PeopleSignupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
